// Time labels on the hour only. The calendars open at 7:30, and FullCalendar
// counts its label interval from the opening time, so a one-hour interval put
// every label on the half hour (7:30, 8:30, …). Instead the labels come every
// half hour and the :30 ones are left blank, which keeps the 7:30 opening and
// puts 8am, 9am, … where people expect them.
export const HOUR_LABEL_INTERVAL = '00:30:00';

export function hourLabelOnly(arg) {
  return arg.date.getMinutes() === 0 ? arg.text : '';
}

// Every quarter hour across the calendar's day (7:30am to 10pm), for the
// start and end pickers, as { value: 'HH:MM', label: '8:15 AM' }. A time
// already on the event that falls off the list (an old one at 7:10, or past
// 10pm) is kept as its own option, so editing that event never blanks it.
export function quarterHourOptions(current) {
  const opts = [];
  for (let m = 7 * 60 + 30; m <= 22 * 60; m += 15) opts.push(hhmm(m));
  if (current && !opts.includes(current)) opts.push(current);
  return opts.sort().map(value => ({ value, label: label12(value) }));
}

function hhmm(mins) {
  return `${String(Math.floor(mins / 60)).padStart(2, '0')}:${String(mins % 60).padStart(2, '0')}`;
}

function label12(value) {
  const [h, m] = value.split(':').map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${h < 12 ? 'AM' : 'PM'}`;
}
